import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=b40a86c4"
import script from "./VideoPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports